import { useEffect, useState } from 'react'

/**
 * Returns a copy of `value` that only updates after `delayMs` of no further
 * changes. Used to keep a responsive input (search box) decoupled from an
 * expensive downstream effect (an SWR key that fires a network request) — the
 * input updates every keystroke, the debounced value coalesces them.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(id)
  }, [value, delayMs])

  return debounced
}
